import { useQuery } from '@tanstack/react-query';
import { ResponseDashboardGraphics, ResponseFutureFlowKV, ResponseInstruments, ResponseInstrumentTypes, ResponsePortfolios, ResponseSensitivityMeasures } from '../../domain/entities/DashboardEntity';
import { dashboardKeys, dashboardRepository } from '../../infrastructure/DashboardConstants';

export const useGetFutureFlows = () => {
  return useQuery<ResponseFutureFlowKV, Error>({
    queryKey: dashboardKeys.all,
    queryFn: () => dashboardRepository.getAllFutureFlows(),
  });
}

export const useGetPortfolios = () => {
  return useQuery<ResponsePortfolios, Error>({
    queryKey: dashboardKeys.allPortfolio,
    queryFn: () => dashboardRepository.getAllPortfolios(),
  });
}

export const useGetInstruments = () => {
  return useQuery<ResponseInstruments, Error>({
    queryKey: dashboardKeys.allInstruments,
    queryFn: () => dashboardRepository.getAllInstruments(),
  });
}

export const useGetInstrumentTypes = () => {
  return useQuery<ResponseInstrumentTypes, Error>({
    queryKey: dashboardKeys.allInstrumentTypes,
    queryFn: () => dashboardRepository.getAllInstrumentTypes(),
  });
}

export const useGetSensitivityMeasures = () => {
  return useQuery<ResponseSensitivityMeasures, Error>({
    queryKey: dashboardKeys.allSensitivityMeasures,
    queryFn: () => dashboardRepository.getAllSensitivityMeasures(),
  });
}

export const useGetDashboardGraphics = () => {
  return useQuery<ResponseDashboardGraphics, Error>({
    queryKey: dashboardKeys.allDashboardGraphics,
    queryFn: () => dashboardRepository.getAllDashboardGraphics(),
  });
}